import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { ArrowRight, Heart } from 'lucide-react';
import { motion } from 'framer-motion';
import { useAppContext } from '../contexts/AppContext';
import { toast } from 'sonner';
import { BillvastLogo } from '../components/ui/BillvastLogo';
export const Login: React.FC = () => {
  const navigate = useNavigate();
  const {
    login
  } = useAppContext();
  const [activeTab, setActiveTab] = useState<'signin' | 'signup'>('signin');
  const [isLoading, setIsLoading] = useState(false);
  // Sign In State
  const [email, setEmail] = useState('demo@billvast.com');
  const [password, setPassword] = useState('password123');
  // Sign Up State
  const [name, setName] = useState('');
  const [signupEmail, setSignupEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [signupPassword, setSignupPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      login();
      toast.success('Welcome back to Billvast!');
      navigate('/dashboard');
    }, 1000);
  };
  const handleSignup = (e: React.FormEvent) => {
    e.preventDefault();
    if (signupPassword !== confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }
    if (signupPassword.length < 8) {
      toast.error('Password must be at least 8 characters');
      return;
    }
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      login();
      toast.success('Account created successfully!');
      navigate('/dashboard');
    }, 1000);
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8" data-id="element-1305">
      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-1306">
        <div className="flex justify-center" data-id="element-1307">
          <BillvastLogo size="xl" data-id="element-1308" />
        </div>
        <p className="mt-4 text-center text-sm text-brand-text-light" data-id="element-1309">
          Powering Africa's Digital Economy
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-1310">
        <div className="bg-white py-8 px-4 shadow-xl shadow-gray-200/50 sm:rounded-2xl sm:px-10 border border-gray-100" data-id="element-1311">
          {/* Tab Switcher */}
          <div className="flex p-1 bg-gray-100 rounded-xl mb-8" data-id="element-1312">
            <button onClick={() => setActiveTab('signin')} className={`relative flex-1 py-2.5 text-sm font-medium rounded-lg transition-colors ${activeTab === 'signin' ? 'text-brand-text-dark' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-1313">
              {activeTab === 'signin' && <motion.div layoutId="auth-tab" className="absolute inset-0 bg-white rounded-lg shadow-sm" transition={{
              type: 'spring',
              bounce: 0.2,
              duration: 0.6
            }} data-id="element-1314" />}
              <span className="relative z-10" data-id="element-1315">Sign In</span>
            </button>
            <button onClick={() => setActiveTab('signup')} className={`relative flex-1 py-2.5 text-sm font-medium rounded-lg transition-colors ${activeTab === 'signup' ? 'text-brand-text-dark' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-1316">
              {activeTab === 'signup' && <motion.div layoutId="auth-tab" className="absolute inset-0 bg-white rounded-lg shadow-sm" transition={{
              type: 'spring',
              bounce: 0.2,
              duration: 0.6
            }} data-id="element-1317" />}
              <span className="relative z-10" data-id="element-1318">Sign Up</span>
            </button>
          </div>

          {/* Forms */}
          {activeTab === 'signin' ? <motion.form initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.3
        }} className="space-y-6" onSubmit={handleLogin} data-id="element-1319">
              <div data-id="element-1320">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-1321">
                  Email address
                </label>
                <div className="mt-1" data-id="element-1322">
                  <input id="email" name="email" type="email" autoComplete="email" required value={email} onChange={e => setEmail(e.target.value)} className="appearance-none block w-full px-3 py-2.5 border border-gray-300 rounded-xl shadow-sm placeholder-gray-400 focus:outline-none focus:ring-brand-primary focus:border-brand-primary sm:text-sm transition-colors" data-id="element-1323" />
                </div>
              </div>

              <div data-id="element-1324">
                <label htmlFor="password" className="block text-sm font-medium text-gray-700" data-id="element-1325">
                  Password
                </label>
                <div className="mt-1" data-id="element-1326">
                  <input id="password" name="password" type="password" autoComplete="current-password" required value={password} onChange={e => setPassword(e.target.value)} className="appearance-none block w-full px-3 py-2.5 border border-gray-300 rounded-xl shadow-sm placeholder-gray-400 focus:outline-none focus:ring-brand-primary focus:border-brand-primary sm:text-sm transition-colors" data-id="element-1327" />
                </div>
              </div>

              <div className="flex items-center justify-between" data-id="element-1328">
                <div className="flex items-center" data-id="element-1329">
                  <input id="remember-me" name="remember-me" type="checkbox" className="h-4 w-4 text-brand-primary focus:ring-brand-primary border-gray-300 rounded" data-id="element-1330" />
                  <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900" data-id="element-1331">
                    Remember me
                  </label>
                </div>

                <div className="text-sm" data-id="element-1332">
                  <a href="#" className="font-medium text-brand-primary hover:text-brand-primary-dark" data-id="element-1333">
                    Forgot your password?
                  </a>
                </div>
              </div>

              <div data-id="element-1334">
                <button type="submit" disabled={isLoading} className="w-full flex justify-center py-3 px-4 border border-transparent rounded-xl shadow-sm text-sm font-medium text-white bg-brand-primary hover:bg-brand-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-primary transition-colors disabled:opacity-70" data-id="element-1335">
                  {isLoading ? 'Signing in...' : 'Sign in'}
                </button>
              </div>
            </motion.form> : <motion.form initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.3
        }} className="space-y-5" onSubmit={handleSignup} data-id="element-1336">
              <div data-id="element-1337">
                <label className="block text-sm font-medium text-gray-700" data-id="element-1338">
                  Full Name
                </label>
                <div className="mt-1" data-id="element-1339">
                  <input type="text" required value={name} onChange={e => setName(e.target.value)} className="appearance-none block w-full px-3 py-2.5 border border-gray-300 rounded-xl shadow-sm placeholder-gray-400 focus:outline-none focus:ring-brand-primary focus:border-brand-primary sm:text-sm transition-colors" data-id="element-1340" />
                </div>
              </div>

              <div data-id="element-1341">
                <label className="block text-sm font-medium text-gray-700" data-id="element-1342">
                  Email address
                </label>
                <div className="mt-1" data-id="element-1343">
                  <input type="email" required value={signupEmail} onChange={e => setSignupEmail(e.target.value)} className="appearance-none block w-full px-3 py-2.5 border border-gray-300 rounded-xl shadow-sm placeholder-gray-400 focus:outline-none focus:ring-brand-primary focus:border-brand-primary sm:text-sm transition-colors" data-id="element-1344" />
                </div>
              </div>

              <div data-id="element-1345">
                <label className="block text-sm font-medium text-gray-700" data-id="element-1346">
                  Phone Number
                </label>
                <div className="mt-1" data-id="element-1347">
                  <input type="tel" required value={phone} onChange={e => setPhone(e.target.value)} className="appearance-none block w-full px-3 py-2.5 border border-gray-300 rounded-xl shadow-sm placeholder-gray-400 focus:outline-none focus:ring-brand-primary focus:border-brand-primary sm:text-sm transition-colors" data-id="element-1348" />
                </div>
              </div>

              <div data-id="element-1349">
                <label className="block text-sm font-medium text-gray-700" data-id="element-1350">
                  Password
                </label>
                <div className="mt-1" data-id="element-1351">
                  <input type="password" required value={signupPassword} onChange={e => setSignupPassword(e.target.value)} className="appearance-none block w-full px-3 py-2.5 border border-gray-300 rounded-xl shadow-sm placeholder-gray-400 focus:outline-none focus:ring-brand-primary focus:border-brand-primary sm:text-sm transition-colors" data-id="element-1352" />
                </div>
              </div>

              <div data-id="element-1353">
                <label className="block text-sm font-medium text-gray-700" data-id="element-1354">
                  Confirm Password
                </label>
                <div className="mt-1" data-id="element-1355">
                  <input type="password" required value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} className="appearance-none block w-full px-3 py-2.5 border border-gray-300 rounded-xl shadow-sm placeholder-gray-400 focus:outline-none focus:ring-brand-primary focus:border-brand-primary sm:text-sm transition-colors" data-id="element-1356" />
                </div>
              </div>

              <div data-id="element-1357">
                <button type="submit" disabled={isLoading} className="w-full flex justify-center py-3 px-4 border border-transparent rounded-xl shadow-sm text-sm font-medium text-white bg-brand-primary hover:bg-brand-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-primary transition-colors disabled:opacity-70 mt-2" data-id="element-1358">
                  {isLoading ? 'Creating Account...' : 'Create Account'}
                </button>
              </div>

              <p className="text-xs text-center text-gray-500 mt-4" data-id="element-1359">
                You can complete KYC verification in Settings after
                registration.
              </p>
            </motion.form>}

          <div className="mt-6 pt-6 border-t border-gray-100" data-id="element-1360">
            <Link to="/donate" className="w-full inline-flex justify-center items-center gap-2 py-3 px-4 border border-brand-primary/30 rounded-xl shadow-sm bg-brand-primary/5 text-sm font-medium text-brand-primary-dark hover:bg-brand-primary/10 transition-colors" data-id="element-1361">
              <Heart size={18} className="text-brand-primary" data-id="element-1362" />
              Donate as Guest
              <ArrowRight size={16} className="text-brand-primary/50 ml-auto" data-id="element-1363" />
            </Link>
          </div>
        </div>
      </div>
    </div>;
};